import { render, staticRenderFns } from "./importFudouStatus.vue?vue&type=template&id=386e9960&scoped=true"
import script from "./importFudouStatus.vue?vue&type=script&lang=js"
export * from "./importFudouStatus.vue?vue&type=script&lang=js"
import style0 from "./importFudouStatus.vue?vue&type=style&index=0&id=386e9960&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e9960",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386e9960')) {
      api.createRecord('386e9960', component.options)
    } else {
      api.reload('386e9960', component.options)
    }
    module.hot.accept("./importFudouStatus.vue?vue&type=template&id=386e9960&scoped=true", function () {
      api.rerender('386e9960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/lists/importFudouStatus.vue"
export default component.exports